import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Configuration } from '../../app.constants';
import { Observable, BehaviorSubject } from 'rxjs';
import { initChangeDetectorIfExisting } from '@angular/core/src/render3/instructions';
@Injectable({
  providedIn: 'root'
})

    /*
    new-action-center action-update  new-feed-item new-feed-item-pending archive refresh notifications user-updated
    */

export class SocketService {
  private socket : any
  private init= new BehaviorSubject<Boolean>(false);
  public initObs=this.init.asObservable()

  private newAction = new BehaviorSubject<any>('');
  public newActionObs = this.newAction.asObservable();

  private actionUpdate = new BehaviorSubject<number>(0);
  public actionUpdatedObs = this.actionUpdate.asObservable();

  private newFeed = new BehaviorSubject<any>(undefined);
  public newFeedObs = this.newFeed.asObservable();

  private pendingNewFeed = new BehaviorSubject<any>(undefined);
  public pendingNewFeedObs = this.pendingNewFeed.asObservable();

  private archive = new BehaviorSubject<Boolean>(false);
  public archiveObs = this.archive.asObservable();

  private refresh = new BehaviorSubject<Boolean>(false);
  public refreshObs = this.refresh.asObservable();

  private notification = new BehaviorSubject<any>(undefined);
  public notificationObs = this.notification.asObservable();

  private userUpdate = new BehaviorSubject<Boolean>(false);
  public userUpdateObs = this.userUpdate.asObservable();


  private forceLogoutPopup = new BehaviorSubject<Boolean>(false);
  public forceLogoutPopupObs = this.forceLogoutPopup.asObservable();

  constructor(public config: Configuration) {
    // this.socket = io(this.config.SocketUrl);


    // this.socket.on(`sendInit`, function (message) {
    //   this.init.next(true);
    // }.bind(this));

    // this.socket.on(`new-action`, function (message) {
    //   this.newAction.next(message);
    // }.bind(this));

    // this.socket.on(`action-update`, function (message) {
    //   this.actionUpdate.next(message);
    // }.bind(this));

    // this.socket.on(`new-feed-item`, function (message) {
    //   this.newFeed.next(message);
    // }.bind(this));

    // this.socket.on(`new-feed-item-pending`, function (message) {
    //   this.pendingNewFeed.next(message);
    // }.bind(this));

    // this.socket.on(`archive`, function (message) {
    //   this.archive.next(message);
    // }.bind(this));

    // this.socket.on(`refresh`, function (message) {
    //   this.refresh.next(message);
    // }.bind(this));

    // this.socket.on(`notification`, function (message) {
    //   this.notification.next(message);
    // }.bind(this));

    // this.socket.on(`user-updated`, function (message) {
    //   this.userUpdate.next(message);
    // }.bind(this));


    // this.socket.on(`show-logout-pop-up`, function (message) {
    //   this.forceLogoutPopup.next(message);
    // }.bind(this));


  }


  sendInit(associateId){
    this.socket.emit('init',associateId);
  }

disconnect(associateId: string) {
  if (this.socket) {
    this.socket.emit('remove-socket', associateId);
  } 
}

}
